<template>
  <div>
    <resumo-padrao ref="resumo" :vlr-registro="vlrRegistro" />
  </div>
</template>

<script>
export default {
  props: {
    value: null,
  },
  data () {
    return {
      model: {},
    }
  },
  computed: {
    vlrRegistro () {
      const garantias = this.value?.GarantiaSimulacao || []
      return garantias.reduce((s, g) => s + (Number(g?.VlrRegistro) || 0), 0)
    },
    isentaIOF () {
      return (
        this.$api.Estruturadas.isNotaComercial(this.value?.TipoContratoSigla) ||
        this.value?.IsentarIOF
      )
    },
    isSimulacao () {
      return !this.value.Cliente.PessoaDadosContato
    }
  },
  methods: {
    async submit (callback) {
      if (this.isSimulacao) return callback()
      if (this.value.Codigo) {
        await this.$api.Estruturadas.AtualizarCalculoFluxoIrregular(this, this.value.dtoFluxoIrregular)
        await this.$api.Estruturadas.AtualizarDadosPropostaFluxoIrregular(this)
        return callback()
      } else {
        this.$api.Estruturadas.SaveProposta(this, callback)
      }
    },
    async load () {
      if (this.isentaIOF) this.value.dtoFluxoIrregular.IsentarIOF = true
      if (this.isSimulacao) this.value.VlrRegistro = this.vlrRegistro
      const { PMTIrregular } = await this.$api.Estruturadas.CalcularFluxoIrregular(
        this,
        this.value.dtoFluxoIrregular
      ) || {}
      if (PMTIrregular?.Parcelas) {
        PMTIrregular.Parcelas.forEach(p => {
          if (p && p.DtVencimento) p.DtVencimento = p.DtVencimento.split('T')[0]
        })
      }
      await this.setModel({ Proposta: PMTIrregular || {} })
    },
    async setModel ({ Proposta }) {
      const v = this.value
      const proposta = { ...v, ...(Proposta || {}) }
      const totalCredito = Math.round((proposta.VlrTotalCredito || 0) * 100) / 100

      if (this.isentaIOF && !Number.isInteger(totalCredito)) {
        this.model = proposta
        await this.$api.Estruturadas.RoundNotaComercial(this, null, true)
        proposta.VlrTAC = this.model.VlrTAC
      }
      const baseSolicitado =
        proposta.TipoOperacaoCred === 3
          ? (proposta.VlrProdutoBem || 0) - (proposta.VlrEntrada || 0)
          : (proposta.VlrSolicitado || 0)

      let valorSolicitado = baseSolicitado
      let valorTotalSolicitado = baseSolicitado

      if (v.ModeloCalculo === this.$aux.ModeloCalculoEnum.SAC) {
        const custos = (proposta.VlrITBI || 0) +
          (proposta.VlrRegistroImovel || 0) +
          (proposta.VlrRegistroGarantia || 0)
        valorSolicitado += custos
        valorTotalSolicitado += custos
      }
      valorTotalSolicitado += (proposta.VlrTAC || 0) + (this.vlrRegistro || 0)
      if (proposta.OutrosServicos) {
        valorTotalSolicitado +=
          (proposta.VlrSeguro || 0) +
          (proposta.VlrAvaliacao || 0) +
          (proposta.VlrVistoria || 0)
      }
      const resProp = Proposta || {}
      const m = {
        Codigo: v.Codigo,
        Situacao: '',
        SituacaoDescricao: '',
        Cliente: {
          ...proposta.Cliente,
          DocumentoFederal: proposta.DocumentoFederal || v.Cliente?.DocumentoFederal,
          Nome: proposta.Nome || v.Cliente?.Nome
        },
        CodigoCliente: null,
        CodigoSimulacao: proposta.CodigoSimulacao,
        TipoOperacaoCred: proposta.TipoOperacaoCred,
        TipoOperacaoNome: proposta.TipoOperacaoNome,
        TipoCalculoFluxo: proposta.TipoCalculoFluxo,
        TipoContratoDescricao: proposta.TipoContratoDescricao,
        PrimeiraParcela: (proposta.Parcelas || [])[0],
        UltimaParcela: (proposta.Parcelas || [])[(proposta.Parcelas || []).length - 1],
        Prazo: proposta.Prazo,
        VlrSolicitado: valorSolicitado,
        VlrTAC: proposta.VlrTAC,
        VlrTotalSolicitado: valorTotalSolicitado,
        VlrIOF: resProp.IOF,
        VlrTotalFinanciado: (resProp.IOF || 0) + valorTotalSolicitado,
        VlrTotalDivida: resProp.VlrTotalDivida,
        OutrosServicos: proposta.OutrosServicos,
        VlrSeguro: proposta.VlrSeguro,
        VlrAvaliacao: proposta.VlrAvaliacao,
        VlrVistoria: proposta.VlrVistoria,
        PercIndiceFinan: v.PercIndiceFinan,
        PercJurosMensal: (resProp.PercJurosMensal || resProp.TxJurosAoMes),
        PercJurosAnual: (resProp.PercJurosAnual || resProp.TxJurosAoAno),
        PercCETMensal: (resProp.PercCETMensal || resProp.CETaoMes),
        PercCETAnual: (resProp.PercCETAnual || resProp.CETaoAno),
        ModeloCalculo: v.ModeloCalculo,
        TipoIndexador: v.TipoIndexador,
        TipoIndiceFinan: v.TipoIndiceFinan,
        Parcelas: proposta.Parcelas || [],
        GarantiaSimulacao: proposta.GarantiaSimulacao || [],
        VencimentoPersonalizado: proposta.VencimentoPersonalizado ?? false,
        VlrRegistroImovel: proposta.VlrRegistroImovel,
        VlrTxAdmMensal: proposta.VlrTxAdmMensal,
        VlrITBI: proposta.VlrITBI,
        PercSeguroMensal1: proposta.PercSeguroMensal1,
        VlrSeguroMensal1: proposta.VlrSeguroMensal1,
        PercSeguroMensal2: proposta.PercSeguroMensal2,
        VlrSeguroMensal2: proposta.VlrSeguroMensal2
      }
      this.model = { ...this.value, ...m }
      this.$refs.resumo.load(m)
    }
  }
}
</script>
